<template>
  <component :is="tag" :class="labelClass">
    <span class="inline-flex items-center flex-wrap gap-x-2 gap-y-1">
      <span class="inline-flex items-center gap-1.5">
        <slot name="label">{{ label }}</slot>
        <ConfigHelpButton v-if="helpKey" :help-key="helpKey" :size="size" />
      </span>
      <slot />
    </span>
  </component>
</template>

<script setup>
import ConfigHelpButton from './ConfigHelpButton.vue'

defineProps({
  label: { type: String, default: '' },
  helpKey: { type: String, default: '' },
  tag: { type: String, default: 'label' },
  labelClass: { type: String, default: '' },
  size: { type: String, default: 'md' },
})
</script>
